/**
 * Specifies the activity state the test suite is in.
 * - Tag: 3069
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const TestSuiteActivityState = Object.freeze({
    Scheduled: 0,
    Running: 1,
    Completed: 2,
    Cancelled: 3,
} as const);

export type TestSuiteActivityState = (typeof TestSuiteActivityState)[keyof typeof TestSuiteActivityState];
